"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableActionCell = exports.acTableActionCellConfigs = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var path_parser_1 = require("path-parser");
var AcTableActionCell_module_scss_1 = __importDefault(require("./AcTableActionCell.module.scss"));
var AcPopover_1 = require("../display/AcPopover");
var AcActionIconButton_1 = require("../button/AcActionIconButton");
var AcActionDropdown_1 = require("../dropdown/AcActionDropdown");
exports.acTableActionCellConfigs = {
    ocr: {
        icon: 'fas fa-object-group',
    },
    reply: {
        icon: 'far fa-reply',
    },
    view: {
        icon: 'far fa-eye',
    },
    edit: {
        icon: 'far fa-edit',
    },
    dropdown: {
        icon: 'far fa-ellipsis-v',
    },
    download: {
        icon: 'far fa-download',
    },
    dashboard: {
        icon: 'far fa-chart-line',
    },
    answerList: {
        icon: 'far fa-table',
    },
    link: {
        icon: 'far fa-link',
    },
    unlink: {
        icon: 'far fa-unlink',
    },
};
var AcTableActionCell = function (props) {
    var _a = props.actions, actions = _a === void 0 ? [] : _a, data = props.data, functionContext = props.functionContext;
    var history = react_router_dom_1.useHistory();
    var buttons = actions.map(function (action, index) {
        var config = exports.acTableActionCellConfigs[action.type];
        if (!config) {
            config = {};
        }
        var onClick = function () {
            if (action.onClick) {
                action.onClick(data || {}, functionContext || {});
            }
            else if (action.path) {
                var pathParser = new path_parser_1.Path(action.path);
                var path = pathParser.build(data);
                history.push(path);
            }
        };
        if (action.type === 'dropdown') {
            return (react_1.default.createElement(AcActionDropdown_1.AcActionDropdown, { toggleClassName: "ac-table--no-row-click mx-1", key: index, functionContext: functionContext, data: data, icon: config.icon, align: "right", actions: action.dropdownActions }));
        }
        var hidden;
        if (typeof action.hide === 'function') {
            hidden = action.hide(data || {}, functionContext || {});
        }
        else {
            hidden = !!action.hide;
        }
        var disabled;
        if (typeof action.disabled === 'function') {
            disabled = action.disabled(data || {}, functionContext || {});
        }
        else {
            disabled = !!action.disabled;
        }
        var renderActionButton = function () {
            return (!hidden && (react_1.default.createElement(AcActionIconButton_1.AcActionIconButton, { key: index, onClick: onClick, className: "ac-table--no-row-click mx-1 fs-big " + (action.path ? AcTableActionCell_module_scss_1.default.clickable : '') + " " + AcTableActionCell_module_scss_1.default.button, icon: config.icon, disabled: disabled })));
        };
        if (action.tooltipText) {
            return react_1.default.createElement(AcPopover_1.AcPopover, { text: action.tooltipText }, renderActionButton());
        }
        return renderActionButton();
    });
    return react_1.default.createElement("div", { className: "d-flex flex-row justify-content-end" }, buttons);
};
exports.AcTableActionCell = AcTableActionCell;
exports.AcTableActionCell.displayName = 'AcTableActionCell';
//# sourceMappingURL=AcTableActionCell.js.map